// extracted by mini-css-extract-plugin
export default {"titleRender":"RenderCardTitle_titleRender__Ul24b","buttonImage":"RenderCardTitle_buttonImage__T5ELI","image":"RenderCardTitle_image__4KypY"};